<template>
	<v-menu @click.native.stop open-on-hover v-if="myexports.length">
		<template v-slot:activator="{ on }">
            <v-btn v-on="on" icon class="mt-0 mr-0 d-block">
				<v-icon>mdi-file-export</v-icon>
            </v-btn>
		</template>
		<v-list>
			<v-list-item v-for="(exportobj, i) in myexports" :key="i" @click.stop="exportOrder(exportobj)">
				<v-list-item-title>{{ exportobj.name }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
	let Json2csv = require('json2csv');
	import PdfExport from '../../mixins/Exporting';
	import Shortcodes from '../../mixins/Shortcodes';

    export default {
        computed: {
			myexports() {
				return this.$store.state.exports.filter(exportobj => exportobj.assignment_type === this.type);
			},
			fields() {
				return this.$store.state.fields;
			},
        },
        data() {
            return {
            }
        },
		methods: {
			exportCsv(exportobj){
				let headers = [],
					columns = [],
					rows = [];
				for(let x = (this.order.orderitems.length - 1); x >= 0; x--){
					let row = {};
					for(let y = 0, column; column = exportobj.csvcolumns[y]; y++){
						let format = column.value,
							value = this.replaceShortcodes({
								value: format,
								rowindex: x,
								keyedFieldValues: this.keyedFieldValues,
								assignment_type: this.type
							});

						row[column.header] = value;
					}
					rows.push(row);
				}
				try {
					const csv = Json2csv.parse(rows, { eol: '\r\n' });
					let downloadLink = document.createElement("a"),
						blob = new Blob([csv]),
						url = URL.createObjectURL(blob);
					downloadLink.href = url;
					if(exportobj.configuration.filename){
						downloadLink.download = this.replaceShortcodes({
							value: exportobj.configuration.filename,
							keyedFieldValues: this.keyedFieldValues
						}).replace(/\./g, '').replace(/ /g, '_') + '.csv';
					}else{
						downloadLink.download = exportobj.name+'.csv';
					}
					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
				} catch (err) {
					console.error(err);
				}
			},
			exportOrder(exportobj){
				if(exportobj.type === 'csv'){
					this.exportCsv(exportobj);
				}else if(exportobj.type === 'pdf'){
					this.exportPdf(exportobj);
				}
			},
			exportPdf(exportobj){
				try {
					let pdf = this.createPdf(exportobj);
				} catch (err) {
					console.error(err);
				}
			}
		},
		mixins: [Shortcodes, PdfExport],
        props: {
			customer: {
				required: false
			},
			keyedFieldValues: {
				required: false
			},
			order: {
				required: false
			},
			type: {
				default: 'order'
			}
		}
    }
</script>
